import { LitElement, html, css } from 'lit';
import { validateForm, gRecaptcha } from '../../utilities/formsUtilities';
import { accessibility, formStyles, grid } from '../../utilities/styles';
export class AllInEmailVerify extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        alreadyLoggedInMessage: { type: String },
        loggedIn: { type: String },
        supportEmail: { type: String },
        _showForm: { state: true },
        _successMessage: { state: true },
        _errorMessage: { state: true },
        _resendSuccess: { state: true },
        emailArticleUrl: { type: String }
    };
    constructor() {
        super();
        this._resendSuccess = false;
        this._errorMessage = '';
        this._showForm = false;
        this.emailArticleUrl = 'https://allin.zendesk.com/hc/en-gb/articles/4997208698015-How-to-verify-your-account';
    }
    updated(changedProperties) {
        if (changedProperties.has('_showForm') && this._showForm) {
            this.form.focus();
        }
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    render() {
        let markup;
        if (this.loggedIn == 'true') {
            markup = html `\n                <p>${this.alreadyLoggedInMessage}</p>\n            `;
        }
        else if (this._showForm) {
            markup = html `\n               <form action="${this.action}" method="post" @submit=${this._resend}>\n                    <div class="form_inner ${this._resetSuccess ? 'hide' : ''}" >\n                        <div class="message notice" aria-live="polite"></div>\n                        <div class="input-group">\n                            <label for="email">Enter your email to resend your verification email</label>\n                            <input type="email" name="email" id="email" placeholder="Email" aria-required data-error_message="Please enter a valid email address">\n                        </div>\n                        <input type="text" name="login" id="login" class="hp" autocomplete="off">\n                        <input type="submit" value="Submit">\n                    </div>\n                    <div class="notice" aria-live="assertive">\n                        <div class="${this._errorMessage ? '' : 'hide'} error">${this._errorMessage}</div>\n                    </div>\n                </form>`;
        }
        else if (this._resendSuccess) {
            markup = html `\n                <p class="message success">${this._successMessage}</p>\n                <p>Didn't receive the email? <a href="${this.supportEmail}">Click here to contact support</a>.</p>\n            `;
        }
        else {
            markup = html `\n                <slot name="email-verify"></slot>\n                <p><strong>The link in the email will be valid for one hour. Read our <a href="${this.emailArticleUrl}">article on how to verify your email</a>.</strong></p>\n                <p>If you didn't receive the email or it's been over an hour since we sent it, you can <button @click=${this._onShowForm}>resend your verification email</button> or <a href="${this.supportEmail}">contact us</a>.</p>\n            `;
        }
        return html ` \n            <div class="email-verify bg grid grid_50">\n                <div class="inner-padding" aria-live="polite">\n                    ${markup}\n                </div>\n                <div class="cover">\n                    <slot name="image-markup"></slot>\n                </div>\n            </div>\n        `;
    }
    _onShowForm(e) {
        e.preventDefault();
        this._showForm = true;
    }
    async _resend(e) {
        e.preventDefault();
        let valid = validateForm(this.form, this.formResponse);
        if (!valid)
            return;
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        let gTokenValid = await gRecaptcha(this.formResponse, this.action, this.nonce);
        if (!gTokenValid) {
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            return;
        }
        let response = await fetch(this.action, {
            method: 'POST',
            body: formData,
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
                'AllIn-Resend': 'resend',
            }
        });
        try {
            response = await response.json();
            if (response.ok) {
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this._resendSuccess = true;
                this._showForm = false;
                this._successMessage = response.message;
            }
            else {
                this._errorMessage = response.message;
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    static styles = [
        accessibility,
        formStyles,
        grid,
        css `
            .grid{
                background-color:var(--allin-bg-color,#E8E8E8);
            }
            .inner-padding{
                padding:2rem;
            }
            @media screen and (min-width: 1000px) {
                .cover{
                    position:relative;
                    width:100%;
                    height:565px;
                
                    ::slotted(img){
                        position:absolute;
                        width:100%;
                        height:100% !important;
                        object-fit:cover;
                        top:0;
                        left:0;

                    }
                }
            }
            a{
                color:var(--allin-link-color,#472961);
                font-weight:bold;
            }
            
            button{
                background:none;
                border:none;
                padding:0;
                font-size:1rem;
                color:var(--allin-link-color,#472961);
                cursor:pointer;
                text-decoration:underline;
                font-weight:bold;
                font-family:var(--allin-font-family,'Montserrat');
                text-align:left;
                display:inline;
            }

            button:hover{
                font-weight:bold;
                background-color:transparent;
            }
            @media screen and (min-width: 1000px) {
                .grid{
                    min-height:565px;
                }
                .cover{
                    height:100%;
                }
                .inner-padding{
                    padding:3rem;
                }
            }
        `
    ];
}
